<template>
  <div class="h-100">
    <div v-if="!failed" class="h-100">
      <div
        v-if="!carriersLoading"
        class="d-flex col-12 p-0 align-items-center"
        :style="{
          backgroundColor: theme ? theme.locator_number_of_shops_background_color : 'bg-dark',
          height: '56px',
        }"
      >
        <div v-if="carrierBrands && carrierBrands.length > 1" class="d-flex align-items-center ml-auto">
          <label :style="{ color: theme ? theme.locator_number_of_shops_text_color : '#fff' }" class="ml-auto mr-1">Brands:</label>
          <BushelSelect
            :value="selectedCarrierBrand"
            class="mr-3"
            :options="carrierBrands"
            track-by="id"
            label="name"
            style="width: 200px"
            :hide-main-label="true"
            no-padding
            @select="onSelectBrand"
            @remove="onRemoveBrand"
          />
        </div>
        <div
          :class="`${!carrierBrands || carrierBrands.length < 2 ? 'ml-auto' : ''} col-lg-3 h-100 d-flex align-items-center`"
          style="min-width: 300px"
        >
          <p :style="{ color: theme ? theme.locator_number_of_shops_text_color : '#fff' }" class="m-0 font-weight-bold">
            Number Of Shops {{ carriers.length }}
          </p>
        </div>
      </div>
      <div v-if="carriersLoading" class="d-flex h-100 justify-content-center align-items-center">
        <BSpinner label="Loading..." variant="primary" />
      </div>
      <div
        v-else
        class="row m-0 align-items-start"
        :style="{ height: 'calc(100% - 56px)', backgroundColor: theme ? theme.page_background_color : '#fff' }"
      >
        <div :style="{ backgroundColor: theme ? theme.page_background_color : '#fff' }" class="position-relative col-12 col-lg p-0 h-100">
          <GoogleMap
            :key="mapsKey"
            ref="GoogleMaps"
            class="col p-0 h-100"
            style=""
            :zoom="zoom"
            :markers="markers"
            :center="center"
            :api-key="apiKey"
          />
        </div>
        <div
          :style="{ minWidth: '300px', backgroundColor: theme ? theme.page_background_color : '#fff' }"
          class="list col-12 col-lg-3 p-0 h-100 overflow-auto"
        >
          <div v-if="carriers.length > 0" class="h-100">
            <div v-for="(carrier, index) in currentCarriers" :key="index" :style="{ color: theme.page_sidebar_text_color }">
              <StoreLocatorListItem
                :carrier="carrier"
                :theme="theme"
                @directions="() => getDirections(index)"
                @website="() => goToWebsite(index)"
                @selected="triggerMarkerPopup"
                @remove="hideMarkerPopup"
              />
            </div>
          </div>
          <div v-else>
            <div class="alert alert-danger small mt-4"><b>No Carriers Found.</b> Please contact support support.</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="d-flex h-100 justify-content-center align-items-center">
      <div class="alert alert-danger small"><b>Configuration Issue.</b> Please contact support support.</div>
    </div>
  </div>
</template>

<script>
import BSpinner from "@/components/base/BSpinner.vue";
import GoogleMap from "@/components/common/GoogleMaps.vue";
import StoreLocatorListItem from "./storeLocatorListItem.vue";
import * as api from "@/services/api";

export default {
  components: { GoogleMap, BSpinner, StoreLocatorListItem },
  props: {
    companyUuid: { type: String },
    companyTheme: { type: Object, default: null },
    brands: { type: Array, default: () => [] },
    zoom: { type: Number, default: 7 },
  },
  data() {
    return {
      failed: true,
      apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
      carriers: [],
      markers: [],
      carriersLoading: false,
      theme: null,
      type: "order",
      mapsKey: 1,
      center: null,
      carrierBrands: [],
      selectedCarrierBrand: null,
    };
  },
  computed: {
    currentCarriers() {
      if (this.selectedCarrierBrand) {
        return this.carriers.filter((c) => c.brands && c.brands.length > 0 && c.brands.find((b) => b.id == this.selectedCarrierBrand.id));
      }
      return this.carriers;
    },
  },
  watch: {
    companyTheme: {
      handler(o, n) {
        this.theme = this.companyTheme;
        window.theme = this.companyTheme;
        this.setMarkers();
        this.mapsKey += 1;
      },
      deep: true,
    },
    brands: {
      handler(o, n) {
        this.selectedCarrierBrand = null;
        this.getCarriers(this.companyUuid, this.theme ? this.theme.id : "");
      },
      deep: true,
    },
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    const companyUuid = params.get("company") ? params.get("company") : this.companyUuid;
    const theme = params.get("theme") ? params.get("theme") : "";

    if (!companyUuid) {
      this.failed = true;
    } else {
      this.failed = false;
      this.getUserPosition();
      this.getCarriers(companyUuid, theme);
    }
    const vm = this;
    window.getDirections = function (carrierIndex) {
      vm.getDirections(carrierIndex);
    };
    window.getWebsite = function (carrierIndex) {
      vm.goToWebsite(carrierIndex);
    };
  },
  methods: {
    onSelectBrand(selected) {
      this.selectedCarrierBrand = selected;
      this.setMarkers();
      this.mapsKey += 1;
    },
    onRemoveBrand(selected) {
      this.selectedCarrierBrand = null;
      this.setMarkers();
      this.mapsKey += 1;
    },
    getUserPosition() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
        });
      }
    },
    getCarriers(companyUuid, theme) {
      this.carriersLoading = true;

      api.get(`company/${companyUuid}/carriers?theme=${theme}&brand=${this.brands && this.brands.length > 0 ? this.brands : ""}`).then(
        (response) => {
          this.carriersLoading = false;
          if (this.companyTheme && this.companyTheme.id) {
            this.theme = this.companyTheme;
            window.theme = this.companyTheme;
          } else {
            this.theme = response.data.theme;
            window.theme = response.data.theme;
          }

          this.carrierBrands = [];
          if (response.data.orders && response.data.orders.length > 0) {
            this.carriers = [];
            this.carriers = response.data.orders;
            this.carriers.forEach((c) => {
              if (c.brands && c.brands.length > 0) {
                c.brands.forEach((b) => {
                  if (
                    !this.carrierBrands.find((cb) => cb.id == b.id) &&
                    this.brands &&
                    this.brands.length > 0 &&
                    this.brands.find((brnd) => b.id && b.id == brnd)
                  ) {
                    this.carrierBrands.push(b);
                  } else if (
                    !this.carrierBrands.find((cb) => cb.id == b.id) &&
                    (!this.brands || !this.brands.length) &&
                    this.theme &&
                    this.theme.brands &&
                    this.theme.brands.length &&
                    this.theme.brands.find((tb) => tb.id == b.id)
                  ) {
                    this.carrierBrands.push(b);
                  }
                });
              }
            });

            if (!this.center && response.data.center) {
              this.center = {
                lat: parseFloat(response.data.center.lat),
                lng: parseFloat(response.data.center.lng),
              };
            }

            this.setMarkers();
          }
        },
        (error) => {
          this.carriersLoading = false;
          console.log(error);
        },
      );
    },
    getDirections(carrierIndex) {
      const carrier = this.carriers[carrierIndex];
      if (carrier && carrier.seller) {
        const destination = `${carrier.ship_line_one} ${carrier.ship_line_two ? carrier.ship_line_two : ""}, ${carrier.ship_city}, ${
          carrier.ship_state
        }, ${carrier.ship_zip}`;
        const starting = `${carrier.seller.line_one} ${carrier.seller.line_two ? carrier.seller.line_two : ""}, ${carrier.seller.city}, ${
          carrier.seller.state.value
        }, ${carrier.seller.zip}`;
        window.open(`https://www.google.com/maps/dir/${starting}/${destination}`, "_blank");
      } else {
        alert("No directions available");  
      }
    },
    goToWebsite(carrierIndex) {
      const carrier = this.carriers[carrierIndex];
      window.open(carrier.buyer.website_url, "_blank");
    },
    triggerMarkerPopup(locationId) {
      this.$refs.GoogleMaps.triggerBuyerPopupClick(locationId);
    },
    hideMarkerPopup(locationId) {
      this.$refs.GoogleMaps.hidePopup(locationId);
    },
    setMarkers() {
      this.markers = [];
      this.currentCarriers.forEach((carrier, i) => {
        if (carrier.coordinates && carrier.coordinates.lat && carrier.coordinates.lng) {
          const location = {
            lat: parseFloat(carrier.coordinates.lat),
            lng: parseFloat(carrier.coordinates.lng),
          };

          let iconPath = null;
          if (
            ((this.theme.brands && this.theme.brands.length > 0) || (this.brands && this.brands.length > 0)) &&
            carrier.brands &&
            carrier.brands.length > 0 &&
            carrier.brands[0]
          ) {
            // if no specific brand selected we just grab the first one
            if (!this.selectedCarrierBrand && carrier.brands.length > 1) {
              if (!carrier.seller.logoLink.includes("gravatar.com") && (this.theme.brands.length > 1 || this.brands.length > 1)) {
                iconPath = `${carrier.seller.logoLink}?brand-image`;
              } else if (this.brands.length == 1 && carrier.brands.some((b) => b.id == this.brands[0])) {
                const brand = carrier.brands.find((b) => b.id == this.brands[0]);
                if (brand) {
                  iconPath = `${brand.logoLink}?brand-image`;
                }
              } else if (
                (!this.brands || !this.brands.length) &&
                this.theme.brands.length == 1 &&
                carrier.brands.some((b) => b.id == this.theme.brands[0].brand_id)
              ) {
                const brand = carrier.brands.find((b) => b.id == this.theme.brands[0].brand_id);
                if (brand) {
                  iconPath = `${brand.logoLink}?brand-image`;
                }
              } else {
                iconPath = `${carrier.brands[0].logoLink}?brand-image`;
              }
            } else if (!this.selectedCarrierBrand && carrier.brands.length == 1) {
              iconPath = `${carrier.brands[0].logoLink}?brand-image`;
            } else if (this.selectedCarrierBrand && carrier.brands.some((b) => b.id == this.selectedCarrierBrand.id)) {
              const brand = carrier.brands.find((b) => b.id == this.selectedCarrierBrand.id);
              if (brand) {
                iconPath = `${brand.logoLink}?brand-image`;
              }
            }
          } else if (!iconPath && this.theme && this.theme.store_locator_icon) {
            iconPath = this.theme.store_locator_icon;
          } else if (!iconPath) {
            const template = [
              '<?xml version="1.0" encoding="iso-8859-1"?>',
              '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" width="42px" height="42px" xml:space="preserve">',
              '<path stroke="#fff" stroke-width="12" fill="{{ color }}" d="M256,0C161.896,0,85.333,76.563,85.333,170.667c0,28.25,7.063,56.26,20.49,81.104L246.667,506.5 c1.875,3.396,5.448,5.5,9.333,5.5s7.458-2.104,9.333-5.5l140.896-254.813c13.375-24.76,20.438-52.771,20.438-81.021 C426.667,76.563,350.104,0,256,0z M256,256c-47.052,0-85.333-38.281-85.333-85.333c0-47.052,38.281-85.333,85.333-85.333 s85.333,38.281,85.333,85.333C341.333,217.719,303.052,256,256,256z"/>',
              "</svg>",
            ].join("\n");

            const svg = template.replace("{{ color }}", this.theme.locator_map_marker_color);

            iconPath = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
          }

          // brands unique
          const brands = [];
          if (carrier.brands && carrier.brands.length > 0) {
            carrier.brands.forEach((b) => {
              if (!brands.some((brand) => brand.id == b.id) && !this.selectedCarrierBrand) {
                brands.push(b);
              } else if (this.selectedCarrierBrand && b.id == this.selectedCarrierBrand.id && !brands.some((brand) => brand.id == b.id)) {
                brands.push(b);
              }
            });
          }

          this.markers.push({
            id: carrier.id,
            position: location,
            title: carrier.buyer.name,
            icon: {
              url: iconPath,
            },
            popupContent:
              this.theme.brands.length > 0 || this.brands.length > 0
                ? `${
                    "<div style='width: 300px;' class='row m-0 p-0 m-2'>" +
                    "<div class='col-12 p-0 m-0 '>" +
                    "<h6 class='m-0 text-dark font-weight-bold text-uppercase p-0'>"
                  }${carrier.buyer.name}</h6>` +
                  "</div>" +
                  "<div class=' w-100'>" +
                  "<div class='col-12 p-0 row small m-0 mb-2'>" +
                  `<p class='m-0 text-dark'>${carrier.ship_line_one} ${carrier.ship_line_two ? carrier.ship_line_two : ""}</p>` +
                  `<p class='m-0 text-muted'>, ${carrier.ship_city}, ${carrier.ship_state}, ${carrier.ship_zip}</p>` +
                  "</div>" +
                  `<div style="margin-bottom: 5px">${brands.map(
                    (b) => `<img src='${b.logoLink}' style='width: 30px;height: 30px;border-radius: 50%;margin-right: 5px;' />`,
                  )}</div>` +
                  "<div class='d-flex justify-content-between'>" +
                  `<button onclick='getDirections(${i})' style='font-size:10px;background-color: ${window.theme.locator_directions_btn_color};color: ${window.theme.locator_directions_btn_text_color};' class='btn btn-sm p-0 px-2 py-1'><i class='fa fas fa-directions mr-1'></i>Directions</button>` +
                  `${
                    carrier.buyer.website_url
                      ? `<button onclick='getWebsite(${i})' style='font-size:10px;background-color: ${window.theme.locator_website_btn_color};color: ${window.theme.locator_website_btn_text_color}' class='btn btn-success btn-sm ml-1 p-0 px-2 py-1'><i class='fa fas fa-link mr-1'></i>Website</button>`
                      : ""
                  }` +
                  "</div>" +
                  "</div>" +
                  "</div>"
                : `${
                    "<div style='width: 300px;' class='row m-0 p-0 m-2'>" +
                    "<div class='col-12 p-0 m-0 '>" +
                    "<h6 class='m-0 text-dark font-weight-bold text-uppercase p-0'>"
                  }${carrier.buyer.name}</h6>` +
                  "</div>" +
                  "<div class=' w-100'>" +
                  "<div class='col-12 p-0 row small m-0 mb-2'>" +
                  `<p class='m-0 text-dark'>${carrier.ship_line_one} ${carrier.ship_line_two ? carrier.ship_line_two : ""}</p>` +
                  `<p class='m-0 text-muted'>, ${carrier.ship_city}, ${carrier.ship_state}, ${carrier.ship_zip}</p>` +
                  "</div>" +
                  "<div class='d-flex justify-content-between'>" +
                  `<button onclick='getDirections(${i})' style='font-size:10px;background-color: ${window.theme.locator_directions_btn_color};color: ${window.theme.locator_directions_btn_text_color};' class='btn btn-sm p-0 px-2 py-1'><i class='fa fas fa-directions mr-1'></i>Directions</button>` +
                  `${
                    carrier.buyer.website_url
                      ? `<button onclick='getWebsite(${i})' style='font-size:10px;background-color: ${window.theme.locator_website_btn_color};color: ${window.theme.locator_website_btn_text_color}' class='btn btn-success btn-sm ml-1 p-0 px-2 py-1'><i class='fa fas fa-link mr-1'></i>Website</button>`
                      : ""
                  }` +
                  "</div>" +
                  "</div>" +
                  "</div>",
          });
        }
      });

      this.loading = false;
    },
  },
};
</script>
<style>
.store-location-search {
  outline: none;
  border: none;
  background: #fff;
  flex: 1;
  display: block;
}

img[src$="brand-image"] {
  border: 1px solid #000 !important;
  border-radius: 50%;
  background: #fff;
  position: relative;
}

img[src$="brand-image"]:after {
  content: "";
  position: absolute;
  left: 50%;
  top: 100%;
  transform: translate(-50%, 0);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #4285f4;
}
</style>
